import { Link } from 'react-router-dom'
import DescTag from '../../base/Tags/DescTag'
import { useEffect, useRef, useState } from 'react'
import { getImage } from '../../../api/images/images'
import { formatHashtag } from '../../../helpers/utils';

interface StoreProductItemProps {
  imageId: string;
  name: string;
  description: string;
  availColors?: string[];
  unitPrice: number;
  id: number;
  unitType?: string;
  descriptionTags?: string[];
}

const StoreProductItem: React.FC<StoreProductItemProps> = ({
  imageId,
  name,
  description,
  unitPrice,
  unitType,
  id,
  descriptionTags,
}) => {
  const [image, setImage] = useState<string | null>(null)
  const imageRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsVisible(true)
            observer.disconnect()
          }
        })
      },
      { rootMargin: '500px' }
    )

    if (imageRef.current) {
      observer.observe(imageRef.current)
    }

    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    const fetchImage = async () => {
      const imageBlob = await getImage(imageId)
      setImage(imageBlob)
    }

    if (isVisible && imageId) {
      fetchImage()
    }
  }, [isVisible, imageId])

  return (
    <Link
      to={`/home/store/ProductDetails/${id}`}
      className="text-decoration-none"
      style={{ color: 'black' }}
    >
      <div className="bg-white store-product-item p-3" ref={imageRef}>
        <div className="d-flex justify-content-center">
          <img
            src={image || ''}
            alt={name}
            style={{
              width: '100%',           
              height: '200px',         
              objectFit: 'cover',      // Zooms/Crops image to fill dimensions without distortion
              objectPosition: 'center' // Ensures the crop happens from the center
            }}
          />
        </div>
        <div className="ps-1">
          <h4 className="product-name pt-2 pb-2">{name}</h4>
          <div className="product-description text-fiestr-gray mb-1">{description}</div>
          <div className="description-tags line-clamp-2 pb-1">
            {descriptionTags && (
              <div>
                {descriptionTags.map((tag, index) => (
                  <DescTag fontSize="10px" key={index} description={formatHashtag(tag)} />
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div
            className="grey-separator"
            style={{
              height: '3px',
              backgroundColor: '#E3E6ED',
              width: '100%',
              borderRadius: '10px',
            }}
          />
        </div>
        <p className="product-price d-flex justify-content-center pt-3 m-0 fw-bold">
          ${unitPrice.toFixed(2)} /&nbsp;<span className="fw-normal">{unitType}</span>
        </p>
      </div>
    </Link>
  )
}

export default StoreProductItem